document.addEventListener("DOMContentLoaded", function() {
    let header = document.querySelector(".Header");

    if (header) {
        function updateCurrencyText(button) {
            if (!button) return;
            let text = button.innerText.trim();

            if (text === "DKK kr.") {
                button.innerText = "Dansk - DKK";
            } else if (text === "EUR €") {
                button.innerText = "English - EUR €";
            }
        }

        let currencyButton = header.querySelector(".SelectButton");
        updateCurrencyText(currencyButton);

        let dropdownTrigger = header.querySelector(".SelectButton");

        if (dropdownTrigger) {
            dropdownTrigger.addEventListener("click", function() {
                setTimeout(function() {
                    let dropdownItems = header.querySelectorAll(".Popover__Value");
                    dropdownItems.forEach(updateCurrencyText);
                }, 100);
            });
        }
    }
});